export default __webpack_public_path__ + "static/media/logo2.96347ae0.jpg";